import { render, staticRenderFns } from "./natpay.vue?vue&type=template&id=19543278&scoped=true"
import script from "./natpay.vue?vue&type=script&lang=js"
export * from "./natpay.vue?vue&type=script&lang=js"
import style0 from "./natpay.vue?vue&type=style&index=0&id=19543278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19543278",
  null
  
)

export default component.exports